import axios from 'axios';
import { toast } from 'react-toastify';
import { logout } from 'components/auth/auth';

const initTransportInterceptor = (store) => {
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (err) => {
            const status = err?.response?.status;
            const title = err?.response?.data?.message;

            if (status === 401) {
                logout();
                return Promise.reject(err);
            }

            const message = `${status} / ${title}`;
            toast.error(message);

            return Promise.reject(err);
        },
    );
};

const initInterceptors = (store) => {
    initTransportInterceptor(store);
};

export default initInterceptors;
